<template>
  <div class="page">
    <header>
      <NavBar :title="lang('平台件取消上传')"> </NavBar>
      <Filter
        :tab-index="curTabIndex"
        :show="show"
        @change-tab="(value) => changeTab(value)"
        @show-filter="showFilter"
      />
    </header>
    <div class="main">
      <van-popup
        v-model:show="show"
        round
        class="pop"
        position="bottom"
        :style="{ height: 'auto', padding: '20px 16px' }"
        @click-overlay="closePop"
      >
        <div class="searchBox">
          <p style="font-size: 14px">{{ lang('运单编码') }}</p>
          <div class="search">
            <input
              v-model="searchText"
              class="searchInput"
              :placeholder="lang('请输入运单编码')"
            />
            <van-icon
              v-if="searchText"
              class="icon"
              name="clear"
              @click="() => (searchText = '')"
            />
          </div>
        </div>
        <div class="radioBox">
          <van-radio-group
            v-model="checked"
            :icon-size="16"
            checked-color="#E60012"
            direction="horizontal"
          >
            <van-radio name="1">{{ lang('取消时间') }}</van-radio>
            <van-radio name="2">{{ lang('审核时间') }}</van-radio>
            <van-radio name="3">{{ lang('寄件入库时间') }}</van-radio>
          </van-radio-group>
        </div>
        <van-picker-group
          :title="lang('预约日期')"
          class="group"
          :show-toolbar="false"
          :tabs="[
            lang('From') + ' ' + startDate.join('-'),
            lang('到') + ' ' + endDate.join('-')
          ]"
          @confirm="onConfirm"
          @cancel="onCancel"
        >
          <van-date-picker
            v-model="startDate"
            :min-date="minDate"
            :max-date="maxDate"
          />
          <van-date-picker
            v-model="endDate"
            :min-date="minDate"
            :max-date="maxDate"
          />
        </van-picker-group>
        <div class="btnBox">
          <van-button
            plain
            type="default"
            class="reset"
            round
            @click="onCancel"
            >{{ lang('重置') }}</van-button
          >
          <van-button
            class="confirm"
            color="linear-gradient(to right, #FA510F, #FF0000)"
            round
            @click="onConfirm"
          >
            {{ lang('确定') }}
          </van-button>
        </div>
      </van-popup>
      <div class="pullList">
        <PullRefresh
          v-model:refreshing="refreshing"
          :scroll-height="'100%'"
          :loading-text="''"
          class="pull"
          @on-refresh="refreshFn"
        >
          <van-list
            v-model:loading="loading"
            :finished="finished"
            :offset="10"
            :loading-text="' '"
            @load="loadMore"
          >
            <div v-for="(item, index) in dataList" :key="index" class="item">
              <ItemCard
                :data="item"
                :index="index"
                @to-detail="(value) => toDetail(value, item)"
              />
            </div>
          </van-list>
          <NoData v-if="finished && dataList.length === 0" />
        </PullRefresh>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import NavBar from '@/components/NavBar.vue'
import lang from '@/langs'
import { useRoute, useRouter } from 'vue-router'
import { onMounted, ref, watch } from 'vue'
import { chargeRecords, scoreRecords } from '@/api/requests/score'
import { scoreRecordsModel } from '@/model/score/score'
import usePagination from '@/utils/usePagination'
import PullRefresh from '@/components/PullRefresh.vue'
import TimeLine from '@/views/score/component/scoreDetail/timeLine.vue'
import Line from '@/components/line.vue'
import {
  getDateBeforeDays,
  getFormattedDate,
  getSixMonthsAgoDate,
  isDateDifferenceOver31Days
} from '@/utils/aboutDate'
import NoData from '@/components/NoData.vue'
import { groupDataByDate, groupDataByDate2 } from '@/views/score/utils/dealData'
import Filter from '@/views/cancelUpload/component/Filter.vue'
import ItemCard from '@/views/cancelUpload/component/ItemCard.vue'
import { getList } from '@/api/requests/cancelUpload'
import { WaybillQuery } from '@/model/cancelUpload/cancelUpload'
import { useUserStore } from '@/stores/user'
import { nativeLoad, toNativePage } from '@/utils/nativeAPI'
import { showToast } from 'vant'
const route = useRoute()
const router = useRouter()
const curTabIndex = ref(0)
const minDate = ref(getSixMonthsAgoDate())
const maxDate = ref(new Date())
const show = ref(false)
const startDate = ref(getDateBeforeDays(0))
const endDate = ref(getFormattedDate())
const searchText = ref('')
const checked = ref('1')
const { nativeInfo } = useUserStore()
const code = 'PH44000035' //nativeInfo.stationCode
//筛选点确认之前暂存的数据
let tempSearchText = ''
let tempChecked = '1'
let tempStartDate = getDateBeforeDays(0)
let tempEndDate = getFormattedDate()
const paramValue = (): WaybillQuery => {
  let temp = {}
  if (searchText.value !== '') {
    temp = { ...temp, ...{ waybillCodes: [searchText.value] } }
  }
  if (curTabIndex.value !== 0) {
    temp = { ...temp, ...{ auditedStatus: curTabIndex.value } }
  }
  return {
    //   TO_BE_UPLOADED(1,"待上传"),
    // PENDING_APPROVAL(2,"待审核"),
    //     AUDIT_PASSED(3,"已完成"),
    //     AUDIT_REJECTED(4,"已驳回"),
    ...{
      type: Number(checked.value), // 时间类型枚举 1 取消时间 2 审核时间 3寄件入库时间
      startDate: startDate.value.join('-') + ' 00:00:00',
      endDate: endDate.value.join('-') + ' 23:59:59', // datetime 格式字符串
      stationCode: code
    },
    ...temp
  }
}
const toDetail = (value: 'edit' | 'upload' | 'view', data) => {
  toNativePage({
    id: data.id,
    code: data.waybillCode,
    type: value
  })
}
const onConfirm = () => {
  const isValidDate = isDateDifferenceOver31Days(
    new Date(startDate.value.join('-')),
    new Date(endDate.value.join('-'))
  )
  if (isValidDate) {
    showToast(lang('时间间隔不能超过31天'))
    return
  }
  if (new Date(startDate.value.join('-')) > new Date(endDate.value.join('-'))) {
    showToast(lang('结束日期不能早于开始日期'))
    return
  }
  tempSearchText = searchText.value
  tempChecked = checked.value
  tempStartDate = startDate.value
  tempEndDate = endDate.value
  setFunc(getList)
  fetchPageData(paramValue())
  show.value = false
}
const closePop = () => {
  show.value = false
  searchText.value = tempSearchText
  checked.value = tempChecked
  startDate.value = tempStartDate
  endDate.value = tempEndDate
}
const onCancel = () => {
  checked.value = '1'
  searchText.value = ''
  startDate.value = getDateBeforeDays(0)
  endDate.value = getFormattedDate()
}
const changeTab = (value: number) => {
  curTabIndex.value = value
  setFunc(getList)
  fetchPageData(paramValue())
}

const {
  param,
  dataList,
  loading,
  finished,
  refreshing,
  fetchPageData,
  refreshFn,
  loadMore,
  setFunc
} = usePagination(getList)
const showFilter = () => {
  show.value = !show.value
}
onMounted(() => {
  fetchPageData(paramValue())
})
const reset = () => {
  show.value = false
}
onMounted(() => {
  nativeLoad(refreshFn)
})
</script>
<script lang="ts">
export default {
  name: 'CancelUpload'
}
</script>
<style scoped lang="less">
.page {
  height: 100vh;
  width: 100vw;
  display: flex;
  flex-direction: column;
  .main {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: scroll;
    .btnBox {
      padding: 8px;
      display: flex;
      flex-direction: row;
      .reset {
        margin-right: 8px;
        flex: 2;
      }
      .confirm {
        flex: 2;
      }
    }
    .searchBox {
      p {
        color: #3c3c3c;
        font-size: 15px;
        font-weight: 500;
      }
      .search {
        display: flex;
        flex-direction: row;
        position: relative;
        .icon {
          color: rgba(135, 133, 133, 0.58);
          position: absolute;
          right: 12px;
          bottom: 26px;
          font-size: 20px;
        }
        .searchInput {
          flex: 1;
          border-radius: 5px;
          border: 1px solid #d3d3d3;
          margin-top: 14px;
          margin-bottom: 16px;
          color: #999999;
          padding: 11px;
          font-size: 14px;
        }
      }
    }
    .radioBox {
      display: flex;
      margin: 6px 0;
      :deep(.van-radio-group) {
        flex: 1;
        justify-content: space-between;
      }
    }
    :deep(.van-tabs) {
      .van-tabs__wrap {
        display: flex;
        flex-direction: row;
        .van-tabs__nav {
          display: flex;
          flex-direction: row;
          flex: 1;
          .van-tab {
            flex: 2;
            color: rgba(60, 60, 60, 1);
            font-size: 17px;
          }
          .van-tabs__line {
            background: red;
          }
          .van-picker-group__tab-title {
            margin-right: 0;
          }
        }
      }
    }
    .time {
      color: rgba(60, 60, 60, 1);
      font-size: 14px;
      font-weight: 500;
    }
    .pop {
      display: flex;
      flex-direction: column;
      .group {
        flex: 1;
        padding-bottom: 28px;
      }
    }
    .pullList {
      //flex: 1;
      height: 100%;
    }
  }
}
</style>
